"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseWidgetController_1 = require("../BaseWidgetController");
var idGenerator_1 = require("../../idGenerator");
var social_groups_api_1 = require("@wix/social-groups-api");
var APP_TOASTS_STORAGE_KEY = 'appToasts';
var AppToastsController = /** @class */ (function (_super) {
    tslib_1.__extends(AppToastsController, _super);
    function AppToastsController(controllerConfig) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.acknowledge = function (id) {
            var indexToDelete = _this.getToastIndex(id);
            _this.toasts.splice(indexToDelete, 1);
            _this.updateAndSaveToasts();
        };
        _this.add = function (_a) {
            var data = _a.data;
            var newToast = tslib_1.__assign({ id: idGenerator_1.generateId(), at: Date.now() }, data);
            _this.toasts.unshift(newToast);
            _this.updateAndSaveToasts();
        };
        _this.getToastIndex = function (notificationId) {
            return _this.toasts.findIndex(function (notification) { return notification.id === notificationId; });
        };
        return _this;
    }
    AppToastsController.publish = function (pubSub, payload) {
        pubSub.publish(social_groups_api_1.APP_TOAST_EVENT, payload, false);
    };
    AppToastsController.prototype.pageReady = function ($w, wixAPI) {
        this.toasts = this.getSavedToasts();
        this.subscribe();
        this.updateToasts();
        return Promise.resolve();
    };
    AppToastsController.prototype.subscribe = function () {
        this.controllerConfig.platformAPIs.pubSub.subscribe(social_groups_api_1.APP_TOAST_EVENT, this.add.bind(this), false);
    };
    AppToastsController.prototype.updateAndSaveToasts = function () {
        this.saveToasts();
        this.updateToasts();
    };
    AppToastsController.prototype.updateToasts = function () {
        this.setState({
            toasts: {
                entries: this.toasts,
                acknowledge: this.acknowledge,
            },
        });
    };
    AppToastsController.prototype.getSavedToasts = function () {
        try {
            var item = this.getMemoryStorage().getItem(APP_TOASTS_STORAGE_KEY);
            return JSON.parse(item);
        }
        catch (e) {
            return [];
        }
    };
    AppToastsController.prototype.saveToasts = function () {
        this.getMemoryStorage().setItem(APP_TOASTS_STORAGE_KEY, JSON.stringify(this.toasts));
    };
    AppToastsController.emptyState = {
        entries: [],
        acknowledge: function () { },
    };
    return AppToastsController;
}(BaseWidgetController_1.BaseWidgetController));
exports.AppToastsController = AppToastsController;
//# sourceMappingURL=AppToastsController.js.map